import React from 'react'
import { arrayOf, bool, func, shape, string } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import styled from 'styled-components'

const AZUL_BOOKSTER = '#262A5F'
const AZUL_BOOKSTER_HOVER = '#1F2350'

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  width: 100%;
`

const Cabecalho = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`

const Titulo = styled.h3`
  && {
    ${StyleGuide.boldFonte};
    color: ${StyleGuide.cores.preto};
    font-size: 23px;
    line-height: 1.22;
    margin: 0;
    text-align: left;
    text-wrap: balance;
  }
`

const Chamada = styled.p`
  && {
    color: ${StyleGuide.cores.cinza500};
    font-size: 16px;
    line-height: 1.45;
    margin: 0;
    text-align: left;
  }
`

const Instrucoes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const Instrucao = styled.div`
  border-top: ${( { $primeira } ) => ( $primeira ? 'none' : `1px solid ${StyleGuide.cores.cinza200}` )};
  display: grid;
  gap: 16px;
  grid-template-columns: 3px 1fr;
  padding: 14px 0;

  && p {
    color: ${StyleGuide.cores.cinza500};
    font-size: 15px;
    line-height: 1.55;
    margin: 0;
    text-align: left;
  }

  b {
    ${StyleGuide.boldFonte};
    color: ${StyleGuide.cores.preto};
  }
`

const Barra = styled.span`
  background: ${( { $destaque } ) => ( $destaque ? AZUL_BOOKSTER : StyleGuide.cores.cinza300 )};
  border-radius: 2px;
`

const Botao = styled.button`
  && {
    ${StyleGuide.boldFonte};
    background: ${AZUL_BOOKSTER};
    border: 0;
    border-radius: 10px;
    color: ${StyleGuide.cores.branco};
    cursor: pointer;
    font-family: inherit;
    font-size: 16px;
    margin: 0;
    padding: 15px 20px;
    transition: background 0.16s ease;
    width: 100%;

    &:hover {
      background: ${AZUL_BOOKSTER_HOVER};
    }
  }
`

const ModalAjudaLogin = ( { acaoTitulo, showModal, texto, toggleModal } ) => {
  return (
    <Modal
      altura="auto"
      largura="512px"
      onShowModal={ toggleModal }
      show={ showModal }
    >
      <ModalWrapper>
        <Cabecalho>
          <Titulo>{ texto.titulo }</Titulo>
          <Chamada>{ texto.chamada }</Chamada>
        </Cabecalho>

        <Instrucoes>
          { texto.instrucoes.map( ( instrucao, indice ) => (
            <Instrucao
              $primeira={ indice === 0 }
              key={ instrucao.pergunta }
            >
              <Barra $destaque={ instrucao.destaque } />
              <p>
                <b>{ instrucao.pergunta }</b> { instrucao.resposta }
              </p>
            </Instrucao>
          ) ) }
        </Instrucoes>

        <Botao
          onClick={ toggleModal }
          type="button"
        >
          { acaoTitulo }
        </Botao>
      </ModalWrapper>
    </Modal>
  )
}

ModalAjudaLogin.propTypes = {
  'acaoTitulo': string,
  'showModal': bool,
  'texto': shape( {
    'titulo': string,
    'chamada': string,
    'instrucoes': arrayOf( shape( {
      'pergunta': string,
      'resposta': string,
      'destaque': bool
    } ) )
  } ).isRequired,
  'toggleModal': func.isRequired
}

ModalAjudaLogin.defaultProps = {
  'acaoTitulo': 'Entendi, vamos lá',
  'showModal': false
}

export default ModalAjudaLogin
